import React from 'react';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import MyCard from './../MyCard.js';
import Card from 'react-bootstrap/Card';
import Badge from 'react-bootstrap/Badge';

class Devoir3eme extends React.Component{
  render(){
    return(
      <div>
          <Alert variant="danger">
            <h3>
              Devoirs du troisème année secondaire.
            </h3>
          </Alert>

                    <Badge variant="warning"><h4>Devoir - semestre 1  </h4></Badge><br/><br/>
                    <Row>
                        <MyCard
                        title="Devoir 1 - 2021"
                        ty="Devoir"
                        color1="#a691fa"
                        content=""
                        fileUrl="/documents/file/pdf/3/controle/devoir1_semestre1_3eme.pdf" />

                        <MyCard
                        title="Devoir 2 - 2021"
                        ty="Devoir"
                        color1="#a691fa"
                        content=""
                        fileUrl="/documents/file/pdf/3/controle/devoir2_semestre1_3eme.pdf" />


                        <MyCard
                        title="Devoir 3 - 2021"
                        ty="Devoir"
                        color1="#a691fa"
                        content=""
                        fileUrl="/documents/file/pdf/3/controle/devoir3_semestre1_3eme.pdf" />
                    </Row>







      </div>
    );
  }
}

export default Devoir3eme;
